import { Component, OnInit, Inject } from '@angular/core';
import { ExcepcionesComponent } from '../excepciones/excepciones.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'environments/environment';
import { AppState } from 'app/store/app.states';
import { Store } from '@ngrx/store';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { CoalService } from 'app/services/coal.service';
import { formatDate } from '@angular/common';
import { sparrowService } from 'app/services/sparrowService';
import { FacturaService } from 'app/modules/factura/lista-facturas/factura.service';
import { FileService } from 'app/services/file.service';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Obtenemos el Mensaje a mostrar
 */
export interface SendData {
	message: string;
}

@Component({
	selector: 'app-confirm-dialog-opcion',
	templateUrl: './confirm-dialog-opcion.component.html',
	styleUrls: ['./confirm-dialog-opcion.component.sass']
})
export class ConfirmDialogOpcionComponent implements OnInit {

	idFactura;
	constructor(
		public dialog: MatDialog,
		public dialogRef: MatDialogRef<ConfirmDialogOpcionComponent>,
		private readonly store: Store<AppState>,
		private srvcoal: CoalService,
        private sparroService : sparrowService,
        private facturaService: FacturaService,
        private fileService: FileService,
        private _snackBar: MatSnackBar,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.data = this.data.data;
		// //;
	}

	ngOnInit() {
	}

	cancelar(): void {
		try {
			this.dialogRef.close();
		} catch (error) {
			this.excepciones(error, 1);
		}
	}

	excepciones(stack, tipoExcepcion: number) {
		try {
			const dialogRef = this.dialog.open(ExcepcionesComponent, {
				width: '60%',
				data: {
					idTipoExcepcion: tipoExcepcion,
					idOperacion: 1,
					idAplicacion: environment.aplicacionesId,
					moduloExcepcion: 'app-confirm-dialog',
					mensajeExcepcion: '',
					stack
				}
			});

			dialogRef.afterClosed().subscribe((result: any) => {
			});
		} catch (error) {
			console.error(error);
		}
	}

	dowload(url) {
		this.store.dispatch(MostrarSpinner());
		if (url == 'xml') {
			//this.descargarXML();
            this.descargaArchivo(this.data.clave);
		} else {
			this.descargarFactura();
		}
	}

	descargarXML() {
		let factura_response;
		let data = {
			clave: this.idFactura
		}
		this.srvcoal.postService("operacion/GetReporteFacturaXML", data).subscribe(
			(response: any) => {
				// //console.log(response);
				let Dt = new Date();
				let stDT = Dt.toDateString();
				factura_response = response.recordsets[0][0].cfdi_Comprobante;

				var fileToExport = new Blob([factura_response], { type: "text/xml" });
				var a = document.createElement("a");
				a.href = URL.createObjectURL(fileToExport);
				a.target = "_blank";
				a.download = `${''}-${stDT}.xml`
				a.click();
				this.store.dispatch(OcultarSpinner());
			}, (error: any) => {
				this.store.dispatch(OcultarSpinner());
				this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
			});
	}
	descargarFacturaold() {
		// let factura_response;
		// let data = {
		// 	clave: this.idFactura
		// }

		this.store.dispatch(MostrarSpinner());
		let Dt = new Date();
		let stDT = Dt.toDateString();

		this.srvcoal.postServiceBuffer("cfdi/GetFacturaPdf_4_0", {id: this.idFactura})
		.subscribe( (data: any) => {
				const arr = new Uint8Array(data);
				var file = new Blob([arr], { type: 'application/pdf' });
				var fileURL = URL.createObjectURL(file);
				const a = document.createElement('a');
				//Descargar PDF
				a.href = fileURL;
				a.download = `${''}-${stDT}`;
				a.click();
				URL.revokeObjectURL(fileURL);
				this.store.dispatch(OcultarSpinner())
			}, (error: any) => {
				this.store.dispatch(OcultarSpinner())
			});
		// this.srvcoal.postService("operacion/GetReporteFactura", data).subscribe(
		// 	(response: any) => {
		// 		// //console.log(response);
		// 		let Dt = new Date();

		// 		factura_response = response.recordsets;
		// 		this.srvcoal.postServiceBuffer("reportes/SelPdf", factura_response).subscribe(
		// 			(data: any) => {
		// 				const arr = new Uint8Array(data);
		// 				let file = new Blob([arr], { type: 'application/pdf' });
		// 				let fileURL = URL.createObjectURL(file);
		// 				const a = document.createElement('a');
		// 				a.href = fileURL;
		// 				a.download = `${''}-${Dt.toDateString}`;
		// 				a.click();
		// 				URL.revokeObjectURL(fileURL);
		// 				this.store.dispatch(OcultarSpinner());
		// 			}, (error: any) => {
		// 				this.store.dispatch(OcultarSpinner());
		// 				this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
		// 			});
		// 	});
	}

    descargarFactura(){
        switch(this.data.tipofactura){
            case 1 :
                this.facturaF(this.data.clave);
            break;
            case 2 :
                this.facturaF(this.data.clave);
            break;
            case 3:
                this.facturaC(this.data.clave);
            break;
            default :
                this.facturaF(this.data.clave);
            break;
        }

    }

    descargaArchivo(idFactura) {
		this.store.dispatch(MostrarSpinner());
		this.facturaService.getFacturaXml(idFactura).then(data => {
			if (data != null && data.length > 0) {
				var file = data[0];
				/*this.fileService.downloadFile(file.url, file.name).subscribe({
					next: res => { console.log(res); },
					error: err => { console.log(err); }
				});*/

				this.fileService.getFileBlob(file.url).then(data => {
					var element = document.createElement('a');
					var blob = new Blob([data], {
						type: 'text/xml'
					});
					var url = URL.createObjectURL(blob);
					element.href = url;
					element.setAttribute('download', file.name);
					document.body.appendChild(element);
					element.click();
                    this.store.dispatch(OcultarSpinner());
				}).catch(err => {
                    console.log(err);
                    this._snackBar.open(`Ocurrió un error al descargar el archivo: ${err.error?.error?.error?.message}`, 'OK', { duration: 5000 });
                    this.store.dispatch(OcultarSpinner());
                });
			} else {
                this._snackBar.open(`No existe el archivo:`, 'OK', { duration: 5000 });
                this.store.dispatch(OcultarSpinner());
            }
		}).catch(err => {
			console.log(err);
			this.store.dispatch(OcultarSpinner());
            this._snackBar.open("Ocurrio un error al descargar el archivo xml.", 'OK', { duration: 5000 });
		});
	}

    facturaC(idFactura) {
		this.store.dispatch(MostrarSpinner());
		this.facturaService.getComplementoPagoPdf(idFactura).then((body: any) => {
			var name = body.uuid ?? formatDate(new Date(), 'dd/MM/yyyy', 'es-MX');
			this.sparroService.getReport("reportes/CallFeatureNew", body.body, name).then((res: any) => {
                this._snackBar.open(`${res}`, 'OK', { duration: 1000 });
            }).catch(error => {
                this._snackBar.open(`Ocurrió un error al generar el comprobante: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
            });
		}).catch(error => {
			this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
			this.store.dispatch(OcultarSpinner());
            this._snackBar.open("Ocurrio un error al descargar el archivo pdf.", 'OK', { duration: 5000 });
		});
	}
	facturaF(idFactura) {
		this.store.dispatch(MostrarSpinner());
		this.facturaService.getFacturaPdf(idFactura).then((factura_response: any) => {
			var name = factura_response[0][0]?.uuid ?? ((factura_response[0][0]?.serie1 + factura_response[0][0]?.folio1) + " " + formatDate(new Date(), 'dd/MM/yyyy', 'es-MX'));
			this.sparroService.getReport("reportes/SelPdf", factura_response, name).then((res: any) => {
                this._snackBar.open(`${res}`, 'OK', { duration: 1000 });
            }).catch(error => {
                this._snackBar.open(`Ocurrió un error al generar el comprobante: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
            });
		}).catch(error => {
			this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
			this.store.dispatch(OcultarSpinner());
            this._snackBar.open("Ocurrio un error al descargar el archivo pdf.", 'OK', { duration: 5000 });
		});
	}

    /*facturaC(factura){
        this.store.dispatch(MostrarSpinner());
        var body = {idfactura : factura.clave}
        this.srvcoal.postService(`catalogo/selReporteComplementos`, body).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else if (res.excepcion) {
                this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
            } else {
                let body = {
                    logo : 'https://img.freepik.com/vector-premium/icono-empresa-ilustracion-elemento-simple-diseno-simbolo-concepto-empresa-puede-utilizar-web-movil_159242-7784.jpg?w=2000',
                    emisor : {
                        nombre : res.recordsets[0][0].fullname,
                        rfc : res.recordsets[0][0].rfc,
                        direccion : res.recordsets[0][0].direccion,
                        lugar_emision : res.recordsets[0][0].LugarEmosion,
                    },
                    receptor : {
                        nombre : res.recordsets[1][0].nombreRazonSocial,
                        rfc : res.recordsets[1][0].rfc,
                        direccion : res.recordsets[1][0].direccion
                    },
                    productos : res.recordsets[3][0],
                    tproductos : res.recordsets[4][0].total,
                    pagos : res.recordsets[5],
                    DocsRel : res.recordsets[6],
                    footer : {
                        NoCertificado : res.recordsets[7][0].NoCertificado,
                        cadena_original : res.recordsets[7][0].SelloDgitalSAT,
                        sello_emisor : res.recordsets[7][0].Sello,
                        sello_sat : res.recordsets[7][0].SelloSAT,
                        version :res.recordsets[7][0].Version,
                        emisor_cert : res.recordsets[7][0].Certificado,
                        fecha_emit : res.recordsets[7][0].FechaTimbrado,
                        sat_cret : res.recordsets[7][0].NoCertificado,
                        pac : "Lorem",
                        qr : res.recordsets[7][0].SelloDgitalSAT
                    }
                };
                var name = res.recordsets[7][0]?.uuid + " " + formatDate(new Date(), 'dd/MM/yyyy', 'en-GB');
                this.sparroService.getReport("reportes/CallFeatureNew",body,name);
            };

            this.store.dispatch(OcultarSpinner())

        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
        });
    }
    facturaF(factura){
        this.store.dispatch(MostrarSpinner());
        //this.spinner = true;
        var factura_response;
        let data = {
            clave : factura.clave
        }
        this.srvcoal.postService("operacion/GetReporteFactura",data).subscribe(
        (response: any) => {
            factura_response = response.recordsets;
            var name = factura_response[0][0].uuid + " " + formatDate(new Date(), 'dd/MM/yyyy', 'en-GB');;
            this.sparroService.getReport("reportes/SelPdf",factura_response,name);
        });
    }*/

}
